import React, { useState, useMemo } from "react";
import { Link } from "react-router-dom";
import "./Hotels.css";

const FILTER_TABS = ["All", "Europe", "Americas", "Asia", "Middle East"];

const HOTELS = [
  { id: 1, name: "Park Hyatt Zurich", city: "Zurich", country: "Switzerland", flag: "🇨🇭", stars: 5, price: 450, perks: "Room upgrade + $25 F&B + breakfast", badge: "Popular with eToro members", region: "Europe" },
  { id: 2, name: "Mandarin Oriental", city: "London", country: "UK", flag: "🇬🇧", stars: 5, price: 680, perks: "VIP status + late checkout + spa credit", badge: "Trending this month", region: "Europe" },
  { id: 3, name: "Waldorf Astoria", city: "Dubai", country: "UAE", flag: "🇦🇪", stars: 5, price: 520, perks: "Suite upgrade + $50 dining credit", badge: "New addition", region: "Middle East" },
  { id: 4, name: "Sofitel", city: "Tel Aviv", country: "Israel", flag: "🇮🇱", stars: 4, price: 280, perks: "Breakfast + late checkout + WiFi", badge: "Near you", region: "Middle East" },
  { id: 5, name: "Fairmont Monte Carlo", city: "Monte Carlo", country: "Monaco", flag: "🇲🇨", stars: 5, price: 590, perks: "Sea-view upgrade + VIP lounge", badge: "Diamond favorite", region: "Europe" },
  { id: 6, name: "The Peninsula", city: "New York", country: "USA", flag: "🇺🇸", stars: 5, price: 720, perks: "Airport transfer + $100 spa credit", badge: "Top rated", region: "Americas" },
  { id: 7, name: "Four Seasons", city: "Bali", country: "Indonesia", flag: "🇮🇩", stars: 5, price: 480, perks: "Private pool villa + breakfast for two", badge: "Best for wellness", region: "Asia" },
  { id: 8, name: "Ritz-Carlton", city: "Tokyo", country: "Japan", flag: "🇯🇵", stars: 5, price: 550, perks: "Club lounge access + late checkout", badge: "City views", region: "Asia" },
];

const PERKS = [
  { icon: "💰", label: "Best Rate" },
  { icon: "⬆️", label: "Room Upgrade" },
  { icon: "🍽️", label: "F&B Credit" },
  { icon: "📶", label: "Free WiFi" },
  { icon: "🥐", label: "Breakfast" },
  { icon: "👑", label: "VIP Status" },
  { icon: "🕐", label: "Late Checkout" },
];

export default function Hotels() {
  const [activeFilter, setActiveFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [drawerHotel, setDrawerHotel] = useState(null);

  function handleFilterChange(tab) {
    setActiveFilter(tab);
    setDrawerHotel(null);
  }

  const filtered = useMemo(() => {
    return HOTELS.filter((h) => {
      if (activeFilter !== "All" && h.region !== activeFilter) return false;
      if (searchQuery) {
        const q = searchQuery.toLowerCase();
        return h.name.toLowerCase().includes(q) || h.city.toLowerCase().includes(q) || h.country.toLowerCase().includes(q);
      }
      return true;
    });
  }, [activeFilter, searchQuery]);

  return (
    <div className="hotels">
      <section className="hotels-hero">
        <h1 className="hotels-title">Luxury Hotels</h1>
        <p className="hotels-subtitle">900+ handpicked hotels · VIP perks on every stay</p>
      </section>

      <section className="perks-guaranteed">
        <div className="perks-guaranteed-header">
          <span className="perks-guaranteed-badge">✓ Guaranteed</span>
          <span className="perks-guaranteed-label">7 perks on every booking</span>
        </div>
        <div className="perks-guaranteed-list">
          {PERKS.map((p, i) => (
            <span key={i} className="perk-item">
              <span className="perk-icon">{p.icon}</span>
              <span className="perk-label">{p.label}</span>
            </span>
          ))}
        </div>
      </section>

      <div className="hotels-search">
        <input
          type="text"
          placeholder="Search hotel or destination"
          value={searchQuery}
          onChange={(e) => { setSearchQuery(e.target.value); setDrawerHotel(null); }}
          className="hotels-search-input"
        />
      </div>

      <div className="hotels-filters">
        {FILTER_TABS.map((tab) => (
          <button
            key={tab}
            className={`filter-tab ${activeFilter === tab ? "active" : ""}`}
            onClick={() => handleFilterChange(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="hotels-grid">
        {filtered.map((hotel) => (
          <button
            key={hotel.id}
            className="hotel-card"
            onClick={() => setDrawerHotel(hotel)}
            type="button"
          >
            <div className="hotel-card-body">
              <span className="hotel-card-name">{hotel.name}</span>
              <span className="hotel-card-city">{hotel.city}, {hotel.country}</span>
              <span className="hotel-card-price">
                ${hotel.price}<span className="hotel-card-night">/night</span>
              </span>
            </div>
            <span className="hotel-card-arrow">→</span>
          </button>
        ))}
      </div>

      {filtered.length === 0 && (
        <p className="hotels-empty">No hotels found for this filter.</p>
      )}

      <footer className="powered-by">Powered by Visa</footer>

      <div className="hotel-dock">
        <div className="hotel-dock-inner">
          <span className="hotel-dock-count">{HOTELS.length} hotels</span>
          <span className="hotel-dock-text">with VIP perks in your plan</span>
        </div>
      </div>

      {drawerHotel && (
        <>
          <div className="drawer-overlay" onClick={() => setDrawerHotel(null)} />
          <div className="drawer">
            <div className="drawer-handle" />
            <div className="drawer-header">
              <div>
                <h2 className="drawer-title">{drawerHotel.flag} {drawerHotel.name}</h2>
                <p className="drawer-sub">{drawerHotel.city}, {drawerHotel.country} · {"★".repeat(drawerHotel.stars)}</p>
              </div>
              <button className="drawer-close" onClick={() => setDrawerHotel(null)} type="button">×</button>
            </div>

            <div className="drawer-badge-row">
              <span className="drawer-badge">{drawerHotel.badge}</span>
            </div>

            <div className="drawer-stats">
              <div className="drawer-stat">
                <span className="drawer-stat-value">${drawerHotel.price}</span>
                <span className="drawer-stat-label">Per night</span>
              </div>
              <div className="drawer-stat">
                <span className="drawer-stat-value">{drawerHotel.stars}★</span>
                <span className="drawer-stat-label">Rating</span>
              </div>
              <div className="drawer-stat">
                <span className="drawer-stat-value">VIP</span>
                <span className="drawer-stat-label">Status</span>
              </div>
            </div>

            {drawerHotel.perks && (
              <div className="drawer-perks">
                {drawerHotel.perks.split(" + ").map((p, i) => (
                  <span key={i} className="amenity-pill">{p.trim()}</span>
                ))}
              </div>
            )}

            <div className="drawer-actions">
              <Link to={`/hotels/${drawerHotel.id}`} className="drawer-btn outline" onClick={() => setDrawerHotel(null)}>
                Full details
              </Link>
              <button className="drawer-btn primary" type="button" onClick={() => { setDrawerHotel(null); alert("Redirecting to booking partner..."); }}>
                Book Now
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
